export class SaleOrderPreparation {
  constructor(
    public hash?: string,
    public preparationDate?: number,
    public observations?: string
  ) { }

  clone() {
    return new SaleOrderPreparation(
      this.hash,
      this.preparationDate,
      this.observations
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/sale-order-preparation.ts